
export default {

  updateAppidInfo(state, data) {
    state.platformInfo = data;
    state.publicPath = state.stylePath + data.appId + "/pc/";
  },

}


// WEBPACK FOOTER //
// ./src/store/mutations.js